module.exports = __webpack_public_path__ + "static/media/07-Köln.92499bf3.jpg";